import { PRODUCT_TYPE } from "@erp/shared/types/product.types";
const setPrefix = (isCommercial, codeInfo) => {
    return isCommercial ? codeInfo.commercialPrefix : codeInfo.researchPrefix;
};
export const formatProductCode = (item, isCommercial, codeInfo) => {
    const classification = item.classification.split("-");
    const manufacturer = item.manufacturer;
    const model = item.model.replace(/ /g, "_");
    const prefix = setPrefix(isCommercial, codeInfo);
    if (item.type === PRODUCT_TYPE.원부자재) {
        item.productCode = `${prefix}${classification[classification.length - 1]}`;
    }
    else if (item.type === PRODUCT_TYPE.반제품) {
        const spec = item.spec.replace(/ /g, "_");
        item.productCode = `${prefix}${classification[classification.length - 1]}-${manufacturer}-${spec}`;
    }
    else if (item.type === PRODUCT_TYPE.완제품) {
        if (!item.spec) {
            item.spec = "000V 000kW 00Hz 0Level";
        }
        const spec = item.spec
            .replace(/kW/g, "K")
            .replace(/Hz/g, "H")
            .replace(/Level/g, "L")
            .replace(/\s+/g, "");
        item.productCode = `${prefix}${model}-${spec}`;
    }
};
const pickStr = (v, key) => {
    if (typeof v === "string")
        return v;
    if (v && typeof v === "object" && key) {
        const val = v[key];
        return typeof val === "string" ? val : "";
    }
    return "";
};
export const formatMaterialCode = (data, isCommercial = true, codeInfo) => {
    const prefix = setPrefix(isCommercial, codeInfo);
    const classificationRaw = pickStr(data["classification"], "classification");
    const classification = classificationRaw.split("-");
    return `${prefix}${classification[classification.length - 1]}`;
};
export const formatModuleCode = (data, isCommercial = true, codeInfo) => {
    const prefix = setPrefix(isCommercial, codeInfo);
    const classificationRaw = pickStr(data["classification"], "classification");
    const manufacturer = pickStr(data["manufacturer"], "manufacturer");
    const model = pickStr(data["model"]).replace(/ /g, "_");
    const spec = pickStr(data["spec"]).replace(/ /g, "_");
    const classification = classificationRaw.split("-");
    return `${prefix}${classification[classification.length - 1]}-${manufacturer}-${model}-${spec}`;
};
export const formatFinishedGoodCode = (data, isCommercial = true, codeInfo) => {
    const prefix = setPrefix(isCommercial, codeInfo);
    const model = pickStr(data["model"]).replace(/ /g, "_");
    const spec = pickStr(data["spec"])
        .replace(/ /g, "_")
        .replace(/kW/g, "K")
        .replace(/Hz/g, "H")
        .replace(/Level/g, "L")
        .replace(/\s+/g, "");
    return `${prefix}${model}-${spec}`;
};
